//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DateComp from "@/components/public/DateComp";
export default {
  name: "ServeCountForHandle",
  components: {
    DateComp: DateComp
  },
  props: ["queryRang"],
  data: function data() {
    return {
      loading: false,
      list: [],
      showAll: this.queryRang == 1 ? false : true
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      var date = this.$refs.date.getValue();
      this.$http.post("/statistical/all/countServeNum", this.$qs.stringify({
        start: date[0],
        end: date[1] // queryRang: this.queryRang

      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          var arr = [];

          for (var i in data.resData) {
            var obj = {
              value: data.resData[i].finishNum,
              total: data.resData[i].initNum,
              label: data.resData[i].serveName,
              // proporty: (data.resData[i].proporty * 100).toFixed(2) * 1
              proporty: data.resData[i].proporty * 1
            }; // if (i == data.resData.length - 1) {
            //   obj.label = "总量";
            //   obj.proporty = obj.total
            //     ? ((obj.value / obj.total) * 100).toFixed(2) * 1
            //     : 0;
            // }

            arr.push(obj);
          }

          _this.list = arr;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  }
};